import Localizer from "@/localization/Localizer";

export class CreateOrderErrorLocalizer {

    private static readonly matchToKeyMap: { match: string; value: string }[] = [
        { match: 'Missing CompanyID', value: Localizer.setInvoicedMissingCompanyID },
        { match: 'Missing CustomerNo', value: Localizer.setInvoicedMissingCustomerNo },
        { match: 'Missing ProjectNo', value: Localizer.setInvoicedMissingProjectNo },
        { match: 'Missing CostPoolNo', value: Localizer.setInvoicedMissingCostPoolNo },
        { match: 'Missing DeliveryDate', value: Localizer.setInvoicedMissingDeliveryDate },
        { match: 'Missing ReturnDate', value: Localizer.setInvoicedMissingReturnDate },
        { match: 'Missing SalesPersonEmail', value: Localizer.setInvoicedMissingSalesPersonEmail },
        { match: 'No customer found for CustomerNo', value: Localizer.setInvoicedNoCustomerFound },
        { match: 'Customer is not allowed to rent', value: Localizer.setInvoicedCustomerNotAllowedToRent },
        { match: 'CompanyID doesnt match any company', value: Localizer.setInvoicedCompanyIDNoMatch },
        { match: 'SalesPersonEmail doesnt match any sales person', value: Localizer.setInvoicedSalesPersonEmailNoMatch },
        { match: 'CostPoolNo doesnt match any cost pool', value: Localizer.setInvoicedCostPoolNoNoMatch },
        { match: 'ProjectNo doesnt match any project', value: Localizer.setInvoicedProjectNoNoMatch },
        { match: 'CustomerOrdererNo doesnt match any orderer', value: Localizer.setInvoicedCustomerOrdererNoNoMatch },
        { match: 'Customer is missing business ID and ssn', value: Localizer.setInvoicedCustomerMissingIdentifiers },
        { match: 'Unknown error while checking credit', value: Localizer.setInvoicedUnknownCreditCheckError },
        { match: 'No valid credit decision', value: Localizer.setInvoicedNoValidCreditDecision },
        { match: 'Credit not recommended', value: Localizer.setInvoicedCreditNotRecommended },
        { match: 'Unknown error while creating contract', value: Localizer.setInvoicedUnknownContractCreationError },
        { match: 'Unknown error while creating contract row', value: Localizer.setInvoicedUnknownContractRowCreationError },
        { match: 'Missing contract row LineNo', value: Localizer.setInvoicedMissingContractRowLineNo },
        { match: 'Missing contract row ContractLineTypeID', value: Localizer.setInvoicedMissingContractLineTypeID },
        { match: 'Product not found', value: Localizer.setInvoicedProductNotFound },
        { match: 'Missing contract row Quantity', value: Localizer.setInvoicedMissingContractRowQuantity },
        { match: 'Missing contract row DeliveryDateTime', value: Localizer.setInvoicedMissingContractRowDeliveryDateTime },
        { match: 'Missing contract row RentalType', value: Localizer.setInvoicedMissingContractRowRentalType },
        { match: 'Missing ProductDescription', value: Localizer.setInvoicedMissingProductDescription },
        { match: 'Product is removed', value: Localizer.setInvoicedProductRemoved },
        { match: 'Product not available', value: Localizer.setInvoicedProductNotAvailable },
        { match: 'Product is in maintenance', value: Localizer.setInvoicedProductInMaintenance },
        { match: 'Transfer order failed', value: Localizer.setInvoicedTransferOrderFailed }
    ];

    public static getLocalizedMessage(input: string): string {
        if (!input || input.trim() === '') {
            return 'Unknown error';
        }

        const match = this.matchToKeyMap.find(({ match }) =>
            input.toLowerCase().includes(match.toLowerCase())
        );

        return match ? Localizer.setInvoicedCreateOrderErrorWrapper.format(`${match.value} - ${input}`) : Localizer.setInvoicedCreateOrderErrorWrapper.format(input)
    }
}
